import { Link } from 'react-router-dom'
import HeroDestinations from '../components/HeroDestinations.jsx'
import SiteFooter from '../components/SiteFooter.jsx'

export default function HomePage() {
  return (
    <>
      <main id="main-content">
        <section className="hero" aria-labelledby="hero-title">
          <div className="hero-copy" data-reveal="left">
            <span className="eyebrow">Independent digital studio</span>
            <h1 id="hero-title">
              Useful digital <em>spaces</em>, thoughtfully made.
            </h1>
            <p className="hero-lede">
              Zpace Studio brings together focused tools, original web experiences, and public
              work, all designed to be clear, useful, and considered.
            </p>
            <div className="action-row">
              <a className="button button-primary" href="#explore">
                Explore the studio
              </a>
              <Link className="button" to="/privacy/">
                View privacy policies
              </Link>
            </div>
          </div>

          <HeroDestinations />
        </section>

        <section className="section" id="explore" aria-labelledby="explore-title">
          <div className="section-heading" data-reveal>
            <h2 id="explore-title">One studio, a few clear directions.</h2>
            <p>
              Discover the studio’s public projects, tools, and applications all in one
              place.
            </p>
          </div>

          <div className="destination-grid">
            <a className="destination-card" data-reveal href="https://edgezpace.com/">
              <span className="status-chip">Public</span>
              <h3>Edgezpace</h3>
              <p>
                Selected websites, application work, visual archives, and the creative practice
                behind the studio.
              </p>
              <span className="text-link">Visit the portfolio</span>
            </a>

            <a className="destination-card" data-reveal data-reveal-delay="0.16" href="https://accounts.zpacestudio.com/">
              <span className="status-chip status-member">Approved members</span>
              <h3>Member Apps</h3>
              <p>
                Private applications and tools available to approved members.
              </p>
              <span className="text-link">Go to member sign-in</span>
            </a>
          </div>
        </section>

        <section className="section" aria-labelledby="principles-title">
          <div className="principles-wrap">
            <div className="principles-copy" data-reveal="left">
              <span className="eyebrow">How it connects</span>
              <h2 id="principles-title">Different ideas. A shared approach.</h2>
              <p>
                Zpace Studio is home to projects with different purposes, but the same focus:
                making digital experiences useful, clear, and enjoyable to use.
              </p>
            </div>
            <div className="principles-list">
              <article className="principle-card" data-reveal="right">
                <span className="principle-number">01</span>
                <div>
                  <h3>Designed with purpose</h3>
                  <p>
                    Each project starts with a specific need, idea, or problem worth solving.
                  </p>
                </div>
              </article>
              <article className="principle-card" data-reveal="right" data-reveal-delay="0.08">
                <span className="principle-number">02</span>
                <div>
                  <h3>Built to be useful</h3>
                  <p>
                    From full applications to small web tools, function and usability come
                    first.
                  </p>
                </div>
              </article>
              <article className="principle-card" data-reveal="right" data-reveal-delay="0.16">
                <span className="principle-number">03</span>
                <div>
                  <h3>Made to evolve</h3>
                  <p>
                    Projects can grow, change, and improve as new ideas and needs emerge.
                  </p>
                </div>
              </article>
            </div>
          </div>
        </section>

        <section className="section" aria-labelledby="privacy-title">
          <div className="privacy-band" data-reveal>
            <div>
              <span className="card-kicker">Privacy library</span>
              <h2 id="privacy-title">Straightforward policies, easy to find.</h2>
              <p>
                Read how Academic Edge and the Edgezpace website handle information, or contact
                the studio with a privacy or deletion request.
              </p>
            </div>
            <Link className="button button-primary" to="/privacy/">
              Open the privacy library
            </Link>
          </div>
        </section>
      </main>

      <SiteFooter note="Thoughtful digital tools, playful web experiences, and a clear home for public resources." />
    </>
  )
}
